import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "../../css/template/elements.css"
import "../../css/blocks/guaranty.css"


export default class extends Controller {
    connect() {
         $.ajax({
                   type: "get",
                   url: 'https://api.actualoptic.kz:8443/cabinet/warranty/'+ usertoken,
                   contentType: "application/json",
                   acync: false,
                   success: function(data){
                       data.forEach((item)=>{
                           let salesDate = new Date(item.created_at);
                           let salesdateDay = salesDate.getDate();
                           if (salesdateDay < 10){
                               salesdateDay = '0' + salesdateDay
                           }
                           let salesdateMonth = (salesDate.getMonth())+1;
                           if (salesdateMonth < 10){
                               salesdateMonth = '0' + salesdateMonth
                           }

                           let expirationDate = new Date(item.warranty_end);
                           let expirationDateDay = expirationDate.getDate();
                           if (expirationDateDay < 10){
                               expirationDateDay = '0' + expirationDateDay
                           }
                           let expirationDateMonth = expirationDate.getMonth() +1;
                           if (expirationDateMonth < 10){
                               expirationDateMonth = '0' + expirationDateMonth
                           }

                           //проверяем есть ли ID товара
                           let productLink;
                           if(item.product_id === null){
                               productLink = 'https://api.whatsapp.com/send?phone=77753750502&amp;text=Хочу заказать '+item.product_name;
                           } else {
                               productLink = 'https://shop.actualoptic.kz/index.php?route=product/product&product_id='+item.product_id
                           }

                           $('#guarantyGenList').append('' +
                               '<ul class="guaranty__list">\n' +
                               '   <li class="guaranty__name">\n' +
                               '       <strong class="guaranty__name-title">'+item.product_name+'</strong>\n' +
                               '   </li>\n' +
                               '   <li class="guaranty__sales-date"><span class="guaranty__titleMob">Дата покупки</span>'+ salesdateDay + '.' + salesdateMonth + '.' + salesDate.getFullYear() +
                               '</li>\n' +
                               '\n' +
                               '   <li class="guaranty__expiration-date"><span class="guaranty__titleMob">Конец гарантии</span>'+ expirationDateDay + '.' + expirationDateMonth + '.' + expirationDate.getFullYear() +'</li>\n' +
                               '\n' +
                               '   <li class="guaranty__qty"><span class="guaranty__titleMob">Количество</span>'+item.quantity+'</li>' +
                               '<li><a class="btn" href="'+productLink+'">Повторить заказ</a></li>' +

                               '</ul>')
                  
                       })

                   },
                    error(error){
                        console.debug(error);
                        //window.location.replace("404.html");
                    }
               });

    }
}